export default {
  install(app) {
    // Устанавливаем глобальную функцию для заголовка
    app.config.globalProperties.$title = function(titleKey) {
      const appName = this.$root.titleName; // Получаем имя приложения
      return `${titleKey} | ${appName}`;
    };
  }
}
